import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "api-settings-pane" }
const _hoisted_2 = { class: "date-selector" }
const _hoisted_3 = { class: "date-selector" }
const _hoisted_4 = { class: "mt-2 mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      gutter: 20,
      class: "mb-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('reportViewName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  "model-value": $props.settings.reportViewName,
                  size: "small",
                  onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateField('reportViewName', $event))),
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => ($setup.trimField('reportViewName')))
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('reportName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  "model-value": $props.settings.reportName,
                  size: "small",
                  onInput: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateField('reportName', $event))),
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => ($setup.trimField('reportName')))
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('account'),
              class: "mb-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  "model-value": $props.settings.account,
                  size: "small",
                  filterable: "",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.updateField('account', $event)))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.EtradeRequestBodyAccountOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.label,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      gutter: 20,
      class: "mb-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('beginDate')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_select, {
                    "model-value": $props.settings.beginDateType,
                    size: "small",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.updateField('beginDateType', $event)))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dateTypeOptions, (opt) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: opt.value,
                          label: _ctx.$t(opt.label),
                          value: opt.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["model-value"]),
                  ($props.settings.beginDateType === 'specific')
                    ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 0,
                        "model-value": $props.settings.beginDate,
                        type: "date",
                        placeholder: _ctx.$t('selectDate'),
                        size: "small",
                        format: "MM-DD-YYYY",
                        "value-format": "MM-DD-YYYY",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.updateField('beginDate', $event)))
                      }, null, 8, ["model-value", "placeholder"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('endDate')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_select, {
                    "model-value": $props.settings.endDateType,
                    size: "small",
                    onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.updateField('endDateType', $event)))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dateTypeOptions, (opt) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: opt.value,
                          label: _ctx.$t(opt.label),
                          value: opt.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["model-value"]),
                  ($props.settings.endDateType === 'specific')
                    ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 0,
                        "model-value": $props.settings.endDate,
                        type: "date",
                        placeholder: _ctx.$t('selectDate'),
                        size: "small",
                        format: "MM-DD-YYYY",
                        "value-format": "MM-DD-YYYY",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ($setup.updateField('endDate', $event)))
                      }, null, 8, ["model-value", "placeholder"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('filters')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.settings.filters, (filter, filterIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: filterIndex,
        class: "filter-row d-flex align-items-center"
      }, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('name'),
          class: "filter-field-name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: filter.name,
              "onUpdate:modelValue": ($event: any) => ((filter.name) = $event),
              size: "small",
              onBlur: ($event: any) => {
            filter.name = filter.name ? filter.name.trim() : '';
            _ctx.$emit('change');
          },
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('change')))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
          ]),
          _: 2
        }, 1032, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('operator'),
          class: "filter-field-operator"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: filter.operator,
              "onUpdate:modelValue": ($event: any) => ((filter.operator) = $event),
              size: "small",
              onBlur: ($event: any) => {
            filter.operator = filter.operator ? filter.operator.trim() : '';
            _ctx.$emit('change');
          },
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('change')))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
          ]),
          _: 2
        }, 1032, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('values'),
          class: "filter-field-values"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: filter.values,
              "onUpdate:modelValue": ($event: any) => ((filter.values) = $event),
              size: "small",
              placeholder: _ctx.$t('enterValuesSeparatedBySemicolons'),
              onBlur: ($event: any) => {
            filter.values = filter.values ? filter.values.trim() : '';
            _ctx.$emit('change');
          },
              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('change')))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onBlur"])
          ]),
          _: 2
        }, 1032, ["label"]),
        _createVNode(_component_el_button, {
          type: "default",
          size: "small",
          class: "mt-1",
          onClick: ($event: any) => (_ctx.$emit('delete-filter', filterIndex))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]))
    }), 128)),
    _createVNode(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('add-filter')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('addFilter')), 1)
      ]),
      _: 1
    })
  ]))
}